import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { StoreWorkTimeModel, StoreWorkTimeRequest, StoreWorkTimeResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxStoreWorkTimeService {
  constructor(
    private storeWorkTimeApi: StoreWorkTimeResourceService,
  ) {
  }

  getStoreWorkTimeById(id: number): Promise<StoreWorkTimeModel> {
    return firstValueFrom(this.storeWorkTimeApi.getStoreWorkTimeById(id));
  }

  getStoreWorkTimeByStoreAndDate(params: { storeId: number, date: string }): Promise<StoreWorkTimeModel> {
    return firstValueFrom(this.storeWorkTimeApi.getByStoreAndDate(params.date, params.storeId));
  }

  saveStoreWorkTime(body: StoreWorkTimeRequest): Promise<void> {
    return firstValueFrom(this.storeWorkTimeApi.saveStoreWorkTime(body));
  }
}
